import { ROLE } from 'src/types/role'

export const checkRedirect = (role: ROLE) => {
  if (role === ROLE.SUPER_ADMIN || role === ROLE.ADMIN) {
    return '/admin'
  } else if (role === ROLE.COMPANY) {
    return '/company/meetings'
  }
}

// ログイン後などの戻り先として、同一オリジンの相対パスだけを許可する
export const safeInternalPath = (prev: unknown): string | null => {
  if (typeof prev !== 'string' || !prev.startsWith('/') || prev.startsWith('//') || prev.startsWith('/\\')) {
    return null
  }
  const url = new URL(prev.replaceAll('#', '%23'), 'http://localhost')
  if (url.origin !== 'http://localhost') {
    return null
  }
  // 正規化後のパスが // や /\ で始まる場合（例: /.//evil.example → //evil.example）も外部遷移になるため拒否する
  if (url.pathname.startsWith('//') || url.pathname.startsWith('/\\')) {
    return null
  }
  return `${url.pathname}${url.search}`
}
